import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import {
  UserCampaignListApi,
  UserCampaignNumbersApi,
  UserDashboardApi,
  UserDashboardChartApi,
} from "../Api";
import { AxiosResponse } from "axios";
import {
  CampaignCustomersNumberType,
  CampaignsDataType,
  UserChartDataType,
  UserDashboardDataType,
} from "../type";
import { Link } from "react-router-dom";
import { FaUsers } from "react-icons/fa";
import { Line } from "react-chartjs-2";
import { TbMessage2Up } from "react-icons/tb";
import { MdCampaign } from "react-icons/md";

interface CampaignIdType {
  chart: number | null;
  list: number | null;
}

export default function Dashboard() {
  const [dashboardData, setDashboardData] = useState<UserDashboardDataType>();
  const [OutgoingChart, setOutgoingChart] = useState<UserChartDataType[]>([]);
  const [campaignId, setCampaignId] = useState<CampaignIdType>({
    chart: null,
    list: null,
  });
  const [CampaignCustomersNumber, setCampaignCustomersNumber] =
    useState<CampaignCustomersNumberType[]>();
  const [Campaigns, setCampaigns] = useState<CampaignsDataType[]>([]);

  const Dashboard = useQuery({
    queryKey: ["User-Dashborad-API"],
    queryFn: UserDashboardApi,
    onSuccess: (resp: AxiosResponse) => {
      setDashboardData(resp.data);
      setOutgoingChart(resp.data?.userOutgoingChartData);
    },
    enabled: false,
  });

  const { refetch } = useQuery({
    queryKey: ["User-Dashborad-Chart-API", campaignId.chart],
    queryFn: UserDashboardChartApi,
    onSuccess: (resp: AxiosResponse) => {
      setOutgoingChart(resp.data?.userOutgoingChartData || []);
    },
    enabled: false,
  });

  const userCampaignList = useQuery({
    queryKey: ["User-Campaign-List-API"],
    queryFn: UserCampaignListApi,
    onSuccess: (resp: AxiosResponse) => {
      setCampaigns(resp.data?.CampaignList || []);
    },
    enabled: false,
  });

  const RecentNumbers = useQuery({
    queryKey: ["User-Campaign-Numbers-API", campaignId.list],
    queryFn: UserCampaignNumbersApi,
    onSuccess: (resp: AxiosResponse) => {
      setCampaignCustomersNumber(resp.data?.CampaignCustomersNumber || []);
    },
    enabled: false,
  });

  useEffect(() => {
    userCampaignList.refetch();
    Dashboard.refetch();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    refetch();
    // eslint-disable-next-line
  }, [campaignId.chart]);

  useEffect(() => {
    RecentNumbers.refetch();
    // eslint-disable-next-line
  }, [campaignId.list]);

  return (
    <>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Dashboard</h1>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          {/* 4 Box */}
          <div className="row">
            <div className="col-xl-3 col-sm-6 col-12">
              <Link
                to={""}
                className="small-box bg-warning cursor-pointer text-decoration-none"
              >
                <div className="inner">
                  <h3>{dashboardData?.TotalSMSCampaign || 0}</h3>
                  <p>
                    Total SMS <br />
                    Campaign
                  </p>
                </div>
                <div className="icon">
                  <MdCampaign />
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <Link
                to={""}
                className="small-box bg-danger cursor-pointer text-decoration-none"
              >
                <div className="inner">
                  <h3>{dashboardData?.TotalOutgoingSMS || 0}</h3>
                  <p>
                    Total Outgoing <br /> SMS
                  </p>
                </div>
                <div className="icon">
                  <TbMessage2Up />
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <Link
                to={""}
                className="small-box bg-info cursor-pointer text-decoration-none"
              >
                <div className="inner">
                  <h3>{dashboardData?.CurrentMonthOutgoingSMS || 0}</h3>
                  <p>
                    Total Current <br /> Month Outgoing SMS
                  </p>
                </div>
                <div className="icon">
                  <TbMessage2Up />
                </div>
              </Link>
            </div>
            <div className="col-xl-3 col-sm-6 col-12">
              <Link
                to={""}
                className="small-box bg-dark cursor-pointer text-decoration-none"
              >
                <div className="inner">
                  <h3>{dashboardData?.TotalChatWithCustomer || 0}</h3>
                  <p>
                    Total Chat <br />
                    with Customer
                  </p>
                </div>
                <div className="icon">
                  <FaUsers className="text-white-50" />
                </div>
              </Link>
            </div>
          </div>

          <div className="row mt-4">
            {/* Chart */}
            <div className="col-xl-6">
              <div className="card">
                <div className="card-header bg-white w-100 d-flex flex-wrap gap-2 align-items-center">
                  <h5 className="m-0 flex-grow-1">
                    Outgoing SMS{" "}
                    <span className="fs-6 text-secondary">(Current Year)</span>
                  </h5>
                  <select
                    style={{ width: 240 }}
                    value={!campaignId.chart ? "All" : campaignId.chart}
                    className="form-control"
                    onChange={(e) => {
                      if (e.target.value === "All")
                        return setCampaignId({ ...campaignId, chart: null });
                      setCampaignId({
                        ...campaignId,
                        chart: Number(e.target.value),
                      });
                    }}
                  >
                    <option value="All">All</option>
                    {Campaigns?.map((item, i) => (
                      <option key={i} value={item?.id?.toString()}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="card-body">
                  <div className="responsive-charts">
                    <Line
                      data={{
                        labels: OutgoingChart.map((item) => item.month),
                        datasets: [
                          {
                            label: "Outgoing",
                            data: OutgoingChart.map((item) =>
                              parseInt(item.Outbound, 10)
                            ),
                            borderColor: "rgba(75,192,192,1)",
                            backgroundColor: "rgba(75,192,192,0.2)",
                            fill: true,
                            tension: 0.1,
                          },
                        ],
                      }}
                      options={{ responsive: true, maintainAspectRatio: false }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="card">
                <div className="card-header bg-white w-100 d-flex flex-wrap gap-2 align-items-center">
                  <h2 className="fs-5 mb-0 flex-grow-1">
                    Recent SMS Received Numbers
                  </h2>
                  <select
                    style={{ width: 240 }}
                    value={!campaignId.list ? "All" : campaignId.list}
                    className="form-control"
                    onChange={(e) => {
                      if (e.target.value === "All")
                        return setCampaignId({ ...campaignId, list: null });
                      setCampaignId({
                        ...campaignId,
                        list: Number(e.target.value),
                      });
                    }}
                  >
                    <option value="All">All</option>
                    {Campaigns?.map((item, i) => (
                      <option key={i} value={item?.id?.toString()}>
                        {item?.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive">
                    <table className="table table-hover mb-0 table-bordered text-nowrap">
                      <thead>
                        <tr>
                          <th className="ps-3 sr-no">SR No</th>
                          <th style={{ minWidth: 200 }}>Number</th>
                          <th style={{ width: 100 }} className="text-center">
                            Unread
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {CampaignCustomersNumber?.length ? (
                          CampaignCustomersNumber?.map((item, i) => (
                            <tr key={i}>
                              <td className="ps-3">{i + 1}</td>
                              <td>{item?.from}</td>
                              <td className="text-center">
                                {item?.unread_count}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={5}
                              className="text-center fs-5 fw-semibold"
                            >
                              No data found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
